export const imageCodes = {
    background: {
        code: "${merchantId}_tmpl_img_37",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fab.jpg?alt=media&token=dab03c2b-2f6c-4677-9875-3cb33164ec65"
    },

    about: {
        code: "${merchantId}_tmpl_img_24",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fabo.png?alt=media&token=33cc1e1f-73e0-4555-beea-1ab9a8f754be"
    },

    about1: {
        code: "${merchantId}_tmpl_img_25",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fabo1.png?alt=media&token=70a7f4d0-bc28-446b-be31-231ceb547702"
    },

    about2: {
        code: "${merchantId}_tmpl_img_26",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fabo2.png?alt=media&token=54a0c65c-fbab-42ad-89d0-ee83efed7ea4"
    },

    about3: {
        code: "${merchantId}_tmpl_img_27",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fabo3.png?alt=media&token=f90b9d75-1bbd-49fd-bb6c-31e567c93878"
    },

    about4: {
        code: "${merchantId}_tmpl_img_28",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fabo4.png?alt=media&token=4ba164da-9806-4f32-859b-404d4f1255fe"
    },

    love: {
        code: "${merchantId}_tmpl_img_30",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flove.png?alt=media&token=1ce1f680-9292-43a6-9a9e-94297eb76b29"
    },

    love1: {
        code: "${merchantId}_tmpl_img_31",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flove1.png?alt=media&token=d433e84e-0c23-4a4e-8ac0-d705e1fa9de3"
    },

    love2: {
        code: "${merchantId}_tmpl_img_32",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flove2.png?alt=media&token=17c52902-d2d8-490b-9c0f-5d2c5b0212d4"
    },

    love3: {
        code: "${merchantId}_tmpl_img_33",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flove3.png?alt=media&token=4845f117-e1fd-46db-9b9f-c9b17acebf0c"
    },
    
    support: {
        code: "${merchantId}_tmpl_img_34",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Frec.png?alt=media&token=4e763b4b-d8a3-47e4-8856-5c7d8043f479"
    },
    
    support1: {
        code: "${merchantId}_tmpl_img_35",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Frec1.png?alt=media&token=0b41e848-1664-4076-9107-aa79c5e7bb7e"
    },
    
    support2: {
        code: "${merchantId}_tmpl_img_36",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Frec2.png?alt=media&token=b770908b-edc1-4400-9680-8f0ebe072dc3"
    },

    support3: {
        code: "${merchantId}_tmpl_img_37",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Frec3.png?alt=media&token=e1f87532-6e5f-4ea2-8d34-199dc55a4cff"
    },
}

export const titleCodes = {
    aboutTitle: {
        code: "${merchantId}_tmpl_title_9",
        title: "MADNEST (ရူးသွပ်မှုအသိုက်) "
    },

    title7: {
        code: "${merchantId}_tmpl_title_7",
        title: "Local Supporter "
    },
}
//
export const textCodes = {
    aboutmd: {
        code: "${merchantId}_tmpl_text_3",
        text: "ရူးသွပ်မှုကမ္ဘာထဲက ကြိုဆိုပါတယ်။ လူငယ်တွေရဲ့ နေထိုင်မှု၊ ရူးသွပ်မှု Frequency လေလှိုင်းများကို အရပ်၈မျက်နှာမှ ဖမ်းယူလေ့လာပြီးထုတ်လုပ်ခဲ့သော design များဖြစ်ပါတယ်။ T-shirt တစ်ခုမဟုတ်ပဲပုံပြင်များ၊ ခံစားချက်များ၊ ခံယူချက်များကို မျက်နှာပြင်ကြီးတစ်ခုပေါ်မှာ ဆေးသားများ၊အရောင်များနှင့် ပေါင်းစပ်ဖော်စပ်ပြီး ထုတ်လုပ်ခဲ့ခြင်းဖြစ်ပါတယ်။ ပူလောင်မွန်းကြပ်တဲ့ လူ့အဖွဲ့အစည်းထဲမှာ ရူးသွပ်မှုကမ္ဘာထဲကအမှတ်တရပစ္စည်းလေးများရဲ့ အငွေ့အသက်လေးများကို ခံစားစီးမျောကြည့်လိုက်ပါ။"
    },

    aboutus1: {
        code: "${merchantId}_tmpl_text_2",
        text: "🤵‍♀️ Her.&Co ရဲ့ Admin က Fancy & Fine Jewellery တွေကို စိတ်ဝင်စားသူ တစ်ဦးဖြစ်ပြီး မိမိနည်းတူလူငယ် အမျိုးသမီးများ Trendy & Affordable Jewellery ကို Stylist ကျကျဝတ်စားနိုင်အောင် တစ်ထောင့်တစ်နေရာမှ ပံ့ပိုးပေးနိုင်ရန် ရည်ရွယ်၍ တစ်နိုင်တစ်ပိုင် တည်ထောင်ခဲ့ခြင်း ဖြစ်ပါတယ်"
    },

    aboutus2: {
        code: "${merchantId}_tmpl_text_3",
        text: "✨ Her.& Co ရဲ့ products များမှာ 50% ကတော့ Handmade ( Not Handcraft) ဖြစ်ပြီး ကျန် 50% ကိုတော့ Customer များ Boring မဖြစ်စေရန် ရည်ရွယ်ပြီး Korea Supplies မှ Trendy Products များပါ ထည့်သွင်း ရောင်းပေးပါတယ်ရှင်"
    },

    aboutus3: {
        code: "${merchantId}_tmpl_text_4",
        text: "💛 Her.& Co ဆိုတဲ့ နာမည်လေးအတိုင်း နောက်ပိုင်းမှာ မိန်းကလေး များနဲ့ဆိုင်သော Accessories များ Essential Items များကို ကြိုးစားထုတ်လုပ်သွားမှာ ဖြစ်ပါတယ်ရှင်"
    },

    aboutus4: {
        code: "${merchantId}_tmpl_text_5",
        text: "💌 Her.& Co ရဲ့ အမြတ်ငွေလေးများကို တစ်နိုင်တစ်ပိုင် လိုအပ်သော Donation လေးများမှာလည်းထည့်သွင်း လှူဒါန်းနေပါတယ်ရှင် အားလုံး ဘေးကင်း လုံခြုံပါစေရှင် 💗"
    },
}
export const videoCodes = {
    video1: {
        code: "${merchantId}_tmpl_video_1",
        video: "https://www.youtube.com/embed/Xbqd0mhRM2w"
    }
}